import { CALL_API } from "../../../middlewares/api";

export const SET_SAVELEND_AML_GDRIVE_LINK_REQUEST =
  "SET_SAVELEND_AML_GDRIVE_LINK_REQUEST";
export const SET_SAVELEND_AML_GDRIVE_LINK_SUCCESS =
  "SET_SAVELEND_AML_GDRIVE_LINK_SUCCESS";
export const SET_SAVELEND_AML_GDRIVE_LINK_ERROR =
  "SET_SAVELEND_AML_GDRIVE_LINK_ERROR";

export const set_savelend_gdrive_link = (investorId, gDriveLink) => {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/aml/set-docs-folder-link",
      authenticatedRequest: true,
      method: "POST",
      data: {
        InvestorId: investorId,
        DocsFolderLink: gDriveLink,
      },
      types: [
        SET_SAVELEND_AML_GDRIVE_LINK_REQUEST,
        SET_SAVELEND_AML_GDRIVE_LINK_SUCCESS,
        SET_SAVELEND_AML_GDRIVE_LINK_ERROR,
      ],
    },
  };
};
